//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
//@utilities
import { FormattedText, formatText } from 'core/i18n';
//@constants
const { OPEN_CREDIT } = require('constants/products');

const Product = ({ id, productClassNames, titleClassNames, description, text, line, card, fullCard }) => {
    let renderCard;
    if (card) {
        const classNamescard = classNames('products-list__single__card', {
            'products-list__single__card--full': fullCard,
        });
        renderCard = (
            <div className={classNamescard}>
                <img className="img-responsive" src={card} alt={description} />
            </div>
        );

        if (description.includes(OPEN_CREDIT)) {
            description = formatText('products-applicationOpenCredit') + description;
        }
    }

    const classNamesDescription = classNames({
        'products-list__single__card-description': card,
        'products-list__single__card-description--full': fullCard,
    });

    return (
        <div key={id} id={id} className={productClassNames}>
            <div className="products-list__single clearfix">
                <div className={classNamesDescription}>
                    <h5 className={titleClassNames}>{description}</h5>
                    <span className="dash-blue"></span>
                    <div className="products-list__single-list">
                        <FormattedText value={text} />
                    </div>
                </div>
                {renderCard}
            </div>
            {line}
        </div>
    );
};

Product.propTypes = {
    id: PropTypes.string,
    productclassNames: PropTypes.string,
    titleClassNames: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.string,
    line: PropTypes.object,
    card: PropTypes.string,
    fullCard: PropTypes.bool,
};

Product.defaultProps = {
    id: 'product',
    productclassNames: '',
    titleClassNames: '',
    description: '',
    text: '',
    line: null,
    card: null,
    fullCard: false,
};

module.exports.constructor = Product;
module.exports = Product;
